// shout.js
export function shout(message, meta = {}) {
    // 1. Log to console
    console.error(`[SHOUT] ${message}`, meta);

    // 2. Send to server
    try {

    } catch (e) {
        console.warn('Failed to send error to server:', e);
    }
}

// Optional: attach to global scope
if (typeof window !== 'undefined') {
    window.shout = shout;
}
